import { render } from "./CreateEditSurveyFormModal.vue?vue&type=template&id=5af9cf30"
import script from "./CreateEditSurveyFormModal.vue?vue&type=script&lang=js"
export * from "./CreateEditSurveyFormModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__